export default __webpack_public_path__ + "static/media/a1.4585b27f.png";